import { createReducer, INITIAL_STATE } from '@shared/redux';
import { DEFAULT_CAMPAIGNS_FILTERS_CONFIG, DEFAULT_FILTER } from '../campaigns-filter.constants';
import { NEW_FILTER, UNNAMED_FILTER } from './filters.constants';
import { findCustomFilter, getCustomFilters, getUpdatedCustomFilters } from './filters.utils';

export const LOAD_FILTERS_SUCCESS = '@campaigns/campaigns-filters/filters/LOAD_FILTERS';
export const LOAD_FILTERS_FAILED = '@campaigns/campaigns-filters/filters/LOAD_FILTERS_FAILED';

export const SAVE_CUSTOM_FILTER = '@campaigns/campaigns-filters/filters/SAVE_CUSTOM_FILTER';

export const SELECT_NEW_FILTER = '@campaigns/campaigns-filters/filters/SELECT_NEW_FILTER';
export const SELECT_CUSTOM_FILTER = '@campaigns/campaigns-filters/filters/SELECT_CUSTOM_FILTER';
export const SET_UNNAMED_FILTER = '@campaigns/campaigns-filters/filters/SET_UNNAMED_FILTER';
export const SET_CUSTOM_FILTER = '@campaigns/campaigns-filters/filters/SET_CUSTOM_FILTER';
export const UPDATE_ACTIVE_FILTER = '@campaigns/campaigns-filters/filters/UPDATE_ACTIVE_FILTER';
export const UPDATE_SAVED_FILTER = '@campaigns/campaigns-filters/filters/UPDATE_SAVED_FILTER';
export const VALIDATE_ACTIVE_FILTER_CACHED_CAMPAIGNS = '@campaigns/campaigns-filters/filters/VALIDATE_ACTIVE_FILTER_CACHED_CAMPAIGNS';

export const createGetFiltersState = (entity, id) => state => state.campaigns
    .campaignsFilters.filters[entity][id] || DEFAULT_FILTER;

export const initialState = DEFAULT_CAMPAIGNS_FILTERS_CONFIG;

export const selectNewFilter = ({ type, id }) => ({
    type: SELECT_NEW_FILTER,
    payload: { type, id },
});

export const setUnnamedFilter = ({
    type, id, rules, campaigns,
}) => ({
    type: SET_UNNAMED_FILTER,
    payload: {
        type, id, rules, campaigns,
    },
});

export const setCustomFilter = ({ type, id, filter }) => ({
    type: SET_CUSTOM_FILTER,
    payload: { type, id, filter },
});

export const selectCustomFilter = ({ selectedFilter, type, id }) => ({
    type: SELECT_CUSTOM_FILTER,
    payload: { selectedFilter, type, id },
});

export const loadFilters = loadedFilters => ({
    type: LOAD_FILTERS_SUCCESS,
    payload: loadedFilters,
});

export const loadFiltersFailed = () => ({
    type: LOAD_FILTERS_FAILED,
    payload: {},
});

export const saveCustomFilter = ({ newFilter, type, id }) => ({
    type: SAVE_CUSTOM_FILTER,
    payload: { newFilter, type, id },
});

export const updateActiveFilter = ({ type, id, activeFilter }) => ({
    type: UPDATE_ACTIVE_FILTER,
    payload: { type, id, activeFilter },
});

export const updateSavedFilter = ({ type, id, savedFilter }) => ({
    type: UPDATE_SAVED_FILTER,
    payload: { savedFilter, type, id },
});

export const validateActiveFilterCachedCampaigns = () => ({
    type: VALIDATE_ACTIVE_FILTER_CACHED_CAMPAIGNS,
    payload: {},
});

export const filtersReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [LOAD_FILTERS_SUCCESS]: (state, action) => ({
        ...state,
        ...action.payload,
    }),
    [LOAD_FILTERS_FAILED]: () => initialState,
    [SELECT_NEW_FILTER]: (state, action) => {
        const { type, id } = action.payload;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter: NEW_FILTER,
                    customFilters: getCustomFilters({ state, type, id }),
                },
            },
        };
    },
    [SELECT_CUSTOM_FILTER]: (state, action) => {
        const { type, id } = action.payload;

        const filters = state[type][id];

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter: findCustomFilter((filters), action.payload),
                    customFilters: getCustomFilters({ state, type, id }),
                },
            },
        };
    },
    [SAVE_CUSTOM_FILTER]: (state, action) => {
        const { type, id, newFilter } = action.payload;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter: action.payload.newFilter,
                    customFilters: [
                        ...getCustomFilters({ state, type, id }),
                        newFilter,
                    ],

                },
            },
        };
    },
    [SET_UNNAMED_FILTER]: (state, action) => {
        const {
            type, id, rules, campaigns,
        } = action.payload;

        const filters = state[type][id] ? state[type][id] : DEFAULT_FILTER;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...filters,
                    activeFilter: {
                        name: UNNAMED_FILTER,
                        campaigns,
                        rules,
                    },
                    customFilters: getCustomFilters({ state, type, id }),
                },
            },

        };
    },
    [SET_CUSTOM_FILTER]: (state, action) => {
        const { type, id, filter } = action.payload;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter: filter,
                    customFilters: getCustomFilters({ state, type, id }),
                },
            },

        };
    },
    [UPDATE_ACTIVE_FILTER]: (state, action) => {
        const { type, id, activeFilter } = action.payload;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter,
                },
            },
        };
    },
    [UPDATE_SAVED_FILTER]: (state, action) => {
        const { type, id, savedFilter } = action.payload;

        return {
            ...state,
            [type]: {
                ...state[type],
                [id]: {
                    ...state[type][id],
                    activeFilter: savedFilter,
                    customFilters: getUpdatedCustomFilters({
                        state, type, id, savedFilter,
                    }),
                },
            },
        };
    },
});
